import { useLocation } from "react-router";
import { TeamOnboardingLayout } from "./team-onboarding-layout";
import { DefaultLayout } from "./default-layout";
import type { Team } from "~/lib/db/schema";
import { PUBLIC_ROUTES } from "~/lib/utils/constants";

export const layoutRoutes = [
  {
    path: "/team-onboarding/*",
    layout: TeamOnboardingLayout,
  },
  // { path: "/admin/*", layout: AdminLayout },
  // { path: "/dashboard/*", layout: DashboardLayout },
];

export const Layout = ({
  children,
  teamPromise,
}: {
  children: React.ReactNode;
  teamPromise?: Promise<Team | undefined>;
}) => {
  const location = useLocation();

  // @todo – Removing `/team-onboarding` from PUBLIC_ROUTES
  // causes infinite redirect loop.
  if (location.pathname.includes("/team-onboarding")) {
    return <TeamOnboardingLayout>{children}</TeamOnboardingLayout>;
  }

  if (PUBLIC_ROUTES.includes(location.pathname)) {
    return <>{children}</>;
  }

  for (const { path, layout: CustomLayout } of layoutRoutes) {
    const routeBase = path.replace("/*", "");

    // Check if the current path matches the route base (for index)
    // or starts with the route base (for sub-routes)
    if (
      location.pathname === routeBase ||
      location.pathname.startsWith(routeBase + "/")
    ) {
      return <CustomLayout>{children}</CustomLayout>;
    }
  }

  return (
    <DefaultLayout teamPromise={teamPromise}>
      {children}
    </DefaultLayout>
  );
};
